import { State } from 'src/reducers/types'

export const getUserDataLoaded = (state: State) => state.userData.isUserDataLoaded
